<div class="hidewhenloading" #hidewhenloading>
  <div class="lesson-page">
    <div class="lesson-main">
      <div class="lesson-main__head">
        <h3 class="lesson-main__title" *ngIf="currentBlock?.kind === 'note' && currentBlock.note?.id != 0">
          {{currentBlock.note?.title?.length > 0 ? currentBlock.note.title : "Section " + currentPage}}
        </h3>
        <app-text-reader *ngIf="textReaderReady" [htmltext]="textToRead" [textarea]="textarea" [hasMedia]="hasMedia"></app-text-reader>
        <!-- No `m-0` here: Bootstrap's m-0 is `margin: 0 !important`, which beat the
             `margin-left: auto` that pushes this to the right of the head. -->
        <button type="button" class="btn btn--sm fs-enter"
          *ngIf="currentBlock?.kind === 'note' && notehtml && !hasemptytag"
          (click)="fs.toggle()"
          [attr.aria-pressed]="fs.active"
          title="Read full screen">
          <i class="fas fa-expand" aria-hidden="true"></i>
          <span class="fs-enter__label">Full screen</span>
        </button>
      </div>

      <div appExternallinksdirective class="lp-card lesson-note" *ngIf="currentBlock?.kind === 'note'"
        [class.fs-surface]="fs.active"
        (mousemove)="fs.poke()" (click)="fs.tapped()">
        <div #lessonnotearea class="innerHTML-wrap" *ngIf="notehtml && !hasemptytag"
          [innerHTML]="notehtml">
        </div>
        <div class="lesson-note__empty" *ngIf="!lesson.lecture && (!notehtml || hasemptytag)">
          <ng-container *ngIf="this.lesson.adminuser; else noNote">
            <p class="lp-muted">This lesson has no note yet.</p>
            <button type="button" routerLink="/user/lessonnote"
              [queryParams]="{ moduleID: this.moduleid, classid: this.classid }" class="btn">
              <i class="fas fa-edit"></i> Create Note / Media For Lesson
            </button>
          </ng-container>
          <ng-template #noNote>
            <p class="lp-muted mb-0">There is nothing to read in this lesson yet.</p>
          </ng-template>
        </div>
      </div>

      <!-- Full-screen chrome. Rendered outside the note card so it is not clipped by the
           card's own scrolling, and pinned with position:fixed. It fades out once the
           reader has been still and comes back on pointer movement or, on touch, a tap. -->
      <ng-container *ngIf="fs.active">
        <button type="button" class="btn fs-chrome fs-exit" [class.fs-chrome--hidden]="fs.chromeHidden"
          (click)="fs.set(false)" (mouseenter)="fs.hold()" (mouseleave)="fs.release()"
          title="Exit full screen">
          <i class="fas fa-compress" aria-hidden="true"></i>
          <span>Exit full screen</span>
        </button>

        <nav class="fs-chrome fs-bar" [class.fs-chrome--hidden]="fs.chromeHidden"
          (mouseenter)="fs.hold()" (mouseleave)="fs.release()" aria-label="Lesson pages">
          <button class="btn btn--sm" type="button" (click)="previousPage()"
            [disabled]="currentPage == 1 && !prevlesson">
            <i class="fa fa-angle-left" aria-hidden="true"></i>
            <span>{{currentPage == 1 && prevlesson ? 'Previous Lesson' : 'Previous'}}</span>
          </button>
          <span class="fs-bar__count">Page {{currentPage}} of {{blocks.length}}</span>
          <button class="btn btn--sm" type="button" (click)="nextPage()"
            [disabled]="!enableNextLesson && currentPage == this.blocks.length">
            <span>{{blocks.length == currentPage && enableNextLesson ? 'Next Lesson' : 'Next'}}</span>
            <i class="fa fa-angle-right" aria-hidden="true"></i>
          </button>
        </nav>
      </ng-container>

      <div class="lp-card lesson-game-card" cdkScrollable *ngIf="currentBlock?.kind === 'game'">
        <app-lesson-game [game]="currentBlock.game" (attempted)="onGameAttempted(currentBlock, $event)"></app-lesson-game>
      </div>

      <nav class="lesson-pager" aria-label="Lesson pages">
        <button class="btn btn--sm m-0 lesson-pager__prev" (click)="previousPage()" type="button"
          [disabled]="currentPage == 1 && !prevlesson">
          <i class="fa fa-angle-left" aria-hidden="true"></i>
          <span>{{currentPage == 1 && prevlesson ? 'Previous Lesson' : 'Previous'}}</span>
        </button>

        <span class="lesson-pager__pages" *ngIf="blocks.length > 1">
          <button type="button" class="lesson-pager__dot" *ngFor="let block of blocks; let pageIndex = index"
            [class.is-current]="currentPage == pageIndex + 1" [class.lesson-pager__dot--game]="block.kind === 'game'"
            (click)="gotoPage(pageIndex + 1)"
            attr.aria-label="Go to page {{pageIndex + 1}}"
            [attr.aria-current]="currentPage == pageIndex + 1 ? 'true' : null">{{pageIndex + 1}}</button>
        </span>
        <span class="lesson-pager__count" *ngIf="blocks.length > 1">Page {{currentPage}} of {{blocks.length}}</span>

        <button class="btn btn--sm m-0 lesson-pager__next" (click)="nextPage()" type="button"
          [disabled]="!enableNextLesson && currentPage == this.blocks.length">
          <span>{{blocks.length == currentPage && enableNextLesson ? 'Next Lesson' : 'Next'}}</span>
          <i class="fa fa-angle-right" aria-hidden="true"></i>
        </button>
      </nav>

      <div class="lesson-complete"
        *ngIf="!this.lesson.adminuser && this.currentPage == this.blocks.length && !showInclassAssessement">
        <button type="button" class="btn m-0" [ngClass]="isClassCompleted ? '' : 'bg-warning'"
          (click)="markCompletedclicked()" title="Mark as Complete">
          <i class="fa" [ngClass]="isClassCompleted ? 'fa-check-square' : 'fa-square'" aria-hidden="true"></i>
          {{isClassCompleted ? 'Completed' : 'Mark Completed'}}
        </button>
      </div>

      <!--  absent entirely unless offlineSaveEligible (flag on, not admin,
           entitlement covers this module). Same non-admin-only conditional and visual tier
           as "Mark Completed" above. -->
      <div class="lesson-complete" *ngIf="offlineSaveEligible">
        <button type="button" class="btn m-0" [ngClass]="savedOffline ? '' : 'bg-warning'"
          [disabled]="savingOffline || savedOffline" (click)="saveOfflineClicked()" title="Save for offline">
          <i class="fa" [ngClass]="savedOffline ? 'fa-check-circle' : 'fa-download'" aria-hidden="true"></i>
          {{savingOffline ? 'Saving...' : (savedOffline ? 'Saved offline' : 'Save for offline')}}
        </button>
      </div>

      <section class="lp-card lesson-quiz" *ngIf="showInclassAssessement && quizBlockedOffline">
        <h2 class="lp-card__title">Quiz</h2>
        <p class="lp-muted mb-0">This quiz needs an internet connection. Please reconnect to continue.</p>
      </section>
      <section class="lp-card lesson-quiz" *ngIf="showInclassAssessement && !quizBlockedOffline">
        <h2 class="lp-card__title">Quiz</h2>
        <ul class="list-unstyled m-0" #questionPane>
          <li *ngFor="let question of this.questions; let optionGroupIndex = index">
            <div class="std-qst">
              <h4 class="text-xs mb-3"><span class="text-primary-darker">QUESTION {{optionGroupIndex + 1}}</span>
                of {{this.assessment.questions.length}}
              </h4>
              <div class="inlineOptions innerHTML-wrap" [innerHTML]="question.text | customhtmlsanitizer">
              </div>
            </div>
          </li>
        </ul>
        <div class="lesson-quiz__foot" #buttonPane>
          <p *ngIf="isScored && failedMessage" class="text-warning text-center">{{failedMessage}}</p>

          <div *ngIf="questionCount > 1" class="d-flex flex-wrap gap-1.5 mb-4 mt-2"
            [ngClass]="{'justify-content-start': hideQuestionNavButton !== 2 && questionCount > 1, 'justify-content-between': hideQuestionNavButton !== 2 && questionCount > 1 && hideQuestionNavButton !== 1, 'justify-content-end': hideQuestionNavButton !== 1 }">
            <button type="button" class="btn btn--sm m-0" *ngIf="hideQuestionNavButton !== 2 && questionCount > 1"
              (click)="getQuestionToShow(questionInView.previous)"><i
                class="fa fa-angle-left"></i><span>Previous</span></button>
            <button type="button" class="btn btn--sm m-0" *ngIf="hideQuestionNavButton !== 1"
              (click)="getQuestionToShow(questionInView.next)"><span>Next</span><i class="fa fa-angle-right"></i></button>
          </div>

          <div class="mb-4" *ngIf="this.questions && this.questions.length > 1">
            <button type="button" class="badge badge-lg border-0 m-2 questionBadge" (click)="getQuestionToShow(badgeIndex)"
              *ngFor="let question of this.questions; let badgeIndex = index" [ngClass]="{'red-color': question.isValid === 0}">{{badgeIndex + 1}}</button>
          </div>

          <div class="d-flex justify-content-center flex-wrap gap-1.5">
            <button type="button" class="btn m-0" [disabled]="submitinProgress" (click)="saveAssessment()"
              *ngIf="assessment && showsubmit && !showRetake && !this.lesson.adminuser">Submit</button>
            <button type="button" class="btn m-0" [disabled]="submitinProgress" (click)="retakeAssessment()"
              *ngIf="showRetake && !this.lesson.adminuser">Retake</button>
          </div>
        </div>
      </section>

    </div>

    <aside class="lesson-side">
      <section id="upcomingEvent" class="lp-card">
        <h3 class="lp-card__title">Upcoming / Ongoing Events</h3>

        <p *ngIf="schoolModuleEvent.length === 0" class="lp-muted mb-0">There are no events available.</p>

        <ul class="lp-list" *ngIf="displayEvents.length > 0">
          <li class="lp-list__item" *ngFor="let item of displayEvents">
            <div class="lp-list__body">
              <span class="lp-chip" [class.lp-chip--live]="getStatus(item) === 'Ongoing'">{{getStatus(item)}}</span>
              <span class="lp-list__meta">{{this.util.formatDate(item.inviteStartDate)}} &ndash;
                {{this.util.formatDate(item.inviteEndDate)}}</span>
            </div>
            <button *ngIf="canJoinEvents(item)" type="button" class="btn btn--sm m-0" (click)="joinEvent(item.venue)">Join</button>
          </li>
        </ul>

        <button *ngIf="this.schoolModuleEvent.length > displayEvents.length" type="button" class="btn btn--sm m-auto mt-3"
          (click)="gotoUpcomingEvents()">
          <i class="fas fa-eye"></i> View all {{this.schoolModuleEvent.length}} events
        </button>
      </section>

      <section id="lessonmaterials" class="lp-card">
        <h3 class="lp-card__title">Lesson Materials</h3>

        <p *ngIf="(!classfiles || classfiles.length==0) && !lesson.adminuser" class="lp-muted mb-0">
          There are no lesson materials.</p>

        <button *ngIf="lesson.adminuser && !showlessonfileupload" type="button" class="btn btn--sm m-auto"
          (click)="togglelessonfileupload(1)">
          <i class="fas fa-file"></i> Add file
        </button>

        <form *ngIf="showlessonfileupload" (ngSubmit)="saveclassfile(files.files)">
          <p class="lp-muted text-center">{{classFileName || 'No file selected'}}</p>
          <button (click)="files.click()" type="button" id="filesLabel" class="btn btn--sm m-auto">Select File</button>
          <input #files (change)="classFileName = files.files[0]?.name" type="file" name="files"
            aria-labelledby="filesLabel" id="classfile" class="sr-only" required>
          <div class="d-flex justify-content-around flex-wrap gap-.3 mt-4">
            <button type="submit" class="btn btn--sm m-0" [disabled]="files.files.length < 1">Upload</button>
            <button type="button" class="btn btn--warning btn--sm m-0"
              (click)="showlessonfileupload = false; classFileName = ''">Cancel</button>
          </div>
        </form>

        <div *ngIf="classfiles?.length" class="lp-list mt-3">
          <app-classmaterial *ngFor="let file of classfiles" [file]=file [adminuser]="lesson.adminuser"
            (deletefile)="deleteclassfile($event)">
          </app-classmaterial>
        </div>
      </section>

      <section id="lessonassessments" class="lp-card">
        <h3 class="lp-card__title">Assessments</h3>
        <p class="lp-muted mb-0">{{this.lesson.assessments > 0 ? this.lesson.assessments === 1 ?
          this.lesson.assessments + ' assessment':
          this.lesson.assessments + ' assessments': 'There are no assessments'}} available.</p>
        <p *ngIf="this.lesson.assessments > 0 || this.lesson.adminuser" class="text-xs mt-3 mb-0">
          <a routerLink="/user/assessmentconsole" [queryParams]="{ classid: this.classid, batchid:  this.batchid }"
            class="text-link">{{ this.lesson.adminuser ? 'Manage Assessments' : 'View Assessments'}}</a>
        </p>
      </section>
    </aside>
  </div>
</div>

<div class="modal fade" id="deleteLesson" data-keyboard="false" data-backdrop="static" aria-hidden="true" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Delete Lesson</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <p class="text-center pb-2">Are you sure you want to delete this lesson?</p>
        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <button type="button" class="btn btn--danger m-0" (click)="deleteLesson()">Delete</button>
          <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="deleteLessonnote" data-keyboard="false" data-backdrop="static" aria-hidden="true"
  role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h3 class="modal-title">Delete Note</h3>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body pt-0">
        <p class="text-center pb-2">Every page will be removed permanently!</p>
        <p class="text-center pb-2">Are you sure you want to delete this note?</p>
        <div class="d-flex justify-content-center flex-wrap gap-1.5">
          <button type="button" class="btn btn--danger m-0" (click)="deleteLessonnote()">Delete</button>
          <button type="button" class="btn m-0" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</div>


